import React, { useEffect, useState } from 'react'

import { Box, Divider } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import B2CCardContent from './B2CCardContent'
import B2CCardHeader from './B2CCardHeader'
import B2CCardPreHeader from './B2CCardPreHeader'

import { CustomTheme } from '../../theme/utils'

const useStyles = makeStyles((theme: CustomTheme) => {
  return createStyles({
    card: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      position: 'relative',
      boxShadow:
        '0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14)',
      borderRadius: theme.spacing(4),
      backgroundColor: theme.palette.secondary.contrastText,
    },
    footer: {
      padding: theme.spacing(6),
    },
  })
})

interface Action {
  label?: string
  onClick: () => void
  disabled?: boolean
  isLoading?: boolean
}

interface B2CCardProps {
  className?: string
  dataHookPrefix?: string
  collapsed?: boolean
  cardId?: string
  title?: any
  children?: React.ReactNode
  toggable?: boolean
  actions?: Array<Action>
  menuActions?: Array<Action>
  preHeader?: React.ReactNode
  footer?: React.ReactNode
  menuActionsIcon?: React.ReactNode
  menuActionsButtonText?: string
}

export default function B2CCard({
  className,
  dataHookPrefix,
  collapsed = false,
  cardId = '0',
  title,
  children,
  toggable = false,
  actions,
  menuActions,
  preHeader,
  footer,
  menuActionsIcon,
  menuActionsButtonText,
}: B2CCardProps) {
  const classes = useStyles()
  const [isCollapsed, setIsCollapsed] = useState(collapsed)
  useEffect(() => {
    setIsCollapsed(collapsed)
  }, [collapsed])

  return (
    <Box className={`${className} ${classes.card}`} data-hook={`${dataHookPrefix || cardId}-card`}>
      {preHeader && <B2CCardPreHeader cardId={cardId}>{preHeader}</B2CCardPreHeader>}

      {title && (
        <B2CCardHeader
          cardId={cardId}
          title={title}
          toggable={toggable}
          collapsed={isCollapsed}
          onClickCollapse={() => setIsCollapsed(!isCollapsed)}
          actions={actions}
          menuActions={menuActions}
          menuActionsIcon={menuActionsIcon}
          menuActionsButtonText={menuActionsButtonText}
        />
      )}

      {children && <B2CCardContent collapsed={isCollapsed}>{children}</B2CCardContent>}

      {footer && (
        <>
          <Divider />
          <Box className={classes.footer} data-hook="card-footer">
            {footer}
          </Box>
        </>
      )}
    </Box>
  )
}
